<template>
  <div class="document-container">
    <es-exception v-if="!hasModule('SYS:SEC:ROLEMGR:VIEW')"
      exceptionMessage="Sorry, you are not authorized to access this content."
    />
    <es-loader v-else-if="loading" style="margin: 6.5rem"/>
    <es-exception v-else-if="!loading && loadingError" style="padding: 6.5rem" margin="0rem"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div v-else class="columns">
      <div
        v-if="hasModule('SYS:SEC:USRMGR:VIEW')"
        class="column"
        :class="hasModule('SYS:SEC:ROLEMGR:VIEW') ? 'is-three-quarters' : ''">
        <list-users
          :activeRoles="activeRoles"
          :page="page"
          :search="search"
          :isActive="isActive"
          :roleCodes="roleCodes"
          :districtCodes="districtCodes"
          :schoolCodes="schoolCodes"
          :groupCodes="groupCodes"
          :statuses="statuses"
          :sortField="sortField"
          :sortOrder="sortOrder"
        />
      </div>
      <div
        v-if="hasModule('SYS:SEC:ROLEMGR:VIEW')"
        class="column"
        :class="hasModule('SYS:SEC:USRMGR:VIEW') ? 'is-one-quarter' : ''">
        <role-list :roles="allRoles"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import ListUsers from '@/views/Users/ListUsers.vue';
import RoleList from '@/components/RoleList.vue';

import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    BreadcrumbsManager,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsException,
    EsLoader,
    ListUsers,
    RoleList,
  },
  props: {
    page: {
      type: Number,
    },
    search: {
      type: String,
    },
    isActive: {
      type: Boolean,
    },
    roleCodes: {
      type: Array,
    },
    districtCodes: {
      type: Array,
    },
    schoolCodes: {
      type: Array,
    },
    groupCodes: {
      type: Array,
    },
    statuses: {
      type: Array,
    },
    sortField: {
      type: String,
      default: 'lastName',
    },
    sortOrder: {
      type: String,
      default: 'ASC',
    },
  },
  data() {
    return {
      loading: true,
      loadingError: null,
    };
  },
  created() {
    this.setBreadcrumb([
      { text: 'Security Manager', to: {} },
    ]);
    this.onLoad();
    // TODO: get message to show.
    if (this.$router.currentRoute.params.message) {
      this.showSuccess(this.$router.currentRoute.params.message);
    }
  },
  computed: {
    ...mapGetters('lookups', [
      'activeRoles',
      'allRoles',
    ]),
  },
  methods: {
    ...mapActions('lookups', [
      'loadRoles',
    ]),
    async onLoad() {
      try {
        this.loading = true;
        await Promise.all([
          this.loadRoles(),
        ]);
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    showSuccess(message) {
      this.showNotification('success', Array.isArray(message) ? message : [message]);
    },
  },
};
</script>

<style lang="sass" scoped>
  .columns
    display: flex
    flex-wrap: wrap
  @media screen and (max-width: 60em)
    .column
      flex: 1 0 100%
      &.is-three-quarters
        width: 100% !important
</style>
